import CabeceraIngresos from "../CabeceraIngresos"
import Depositos from "../Depositos"

export const VIngresos = () => {
    return (
        <>
            <CabeceraIngresos />
            <Depositos />
        </>
    )
}
export default VIngresos